import React, {
  useEffect,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setCartCount } from "../../../features/Cart/redux/cartSlice";
import { getCartCount } from "../service/CartCount.service";

const AddtoCart = () => {
  const dispatch = useDispatch();

  const cartCount = useSelector(
    (state) => state.cart.cartCount
  );

  const fetchCartCount = useCallback(async () => {
    try {
      const res = await getCartCount();

      const count = Number(
        res?.count ??
        res?.data?.count ??
        res?.cart_count ??
        res?.data?.cart_count ??
        res?.total_items ??
        res?.data?.total_items ??
        0
      );

      dispatch(setCartCount(count));
    } catch (error) {
      console.error(
        "Fresh Cart Count Error:",
        error
      );
    }
  }, [dispatch]);



  return (
    <div className="box-wishlist">
      <Link
        to="/cart?comingsoon=0"
        className="link-Rottaion"
        style={{
          cursor: "pointer",
          color: "#FFF",
          textDecoration: "none",
        }}
      >
        <i className="bi bi-cart2"></i>

       
          <span className="badge-danger">
            {cartCount}
          </span>

      </Link>
    </div>
  );
};

export default AddtoCart;
